import React from 'react'
import { FormattedMessage } from 'react-intl'

export const STUB_TITLE = (
    <FormattedMessage
        id='stub.title'
        defaultMessage='Внимание!'
    />
)

export const STUB_DESCRIPTION = (
    <FormattedMessage
        id='stub.description'
        defaultMessage='Информация временно недоступна.'
    />
)



// WEBPACK FOOTER //
// ./containers/Stub/constants.jsx